<template>
  <div>
    <nav-bar/>
    <v-form v-if="isLoaded" v-model="isFormValid" class="container profile-border p-0">
      <div class="gray-bg">
        <div class="text-center font-18  py-5 "> ویرایش اطلاعات</div>
      </div>
      <div class="row p-3">
        <div class="col-sm-6 col-12 text-center">
          <div class="mt-5 ">نام</div>
          <div>
            <v-text-field
                v-model="Name"
                class="mt-2"
                solo
                dense
            ></v-text-field>
          </div>
        </div>
        <div class="col-sm-6 col-12 text-center">
          <div class="mt-5 ">نام خانوادگی</div>
          <div>
            <v-text-field
                v-model="Family"
                class="mt-2"
                solo
                dense
            ></v-text-field>
          </div>
        </div>
        <div class="col-sm-6 col-12 text-center">
          <div class="mt-5 ">نام کاربری</div>
          <div>
            <v-text-field
                v-model="UserName"
                class="mt-2"
                solo
                dense
            ></v-text-field>
          </div>
        </div>
        <div class="col-sm-6 col-12 text-center">
          <div class="mt-5 ">پسورد</div>
          <div>
            <v-text-field
                v-model="Password"
                :append-icon="value ? 'fa-eye' : 'fa-eye-slash'"
                @click:append="() => (value = !value)"
                :type="value ? 'password' : 'text'"
                class="mt-2"
                solo
                dense
                :rules="PasswordRules"
            ></v-text-field>
          </div>
        </div>
        <div class="col-sm-6 col-12 text-center">
          <div class="mt-5 ">تکرار پسورد</div>
          <div>
            <v-text-field
                v-model="ConfirmPassword"
                class="mt-2"
                solo
                dense
                :rules="repeatPasswordRules.concat(passwordConfirmationRule)"
                :append-icon="value2 ? 'fa-eye' : 'fa-eye-slash'"
                @click:append="() => (value2 = !value2)"
                :type="value2 ? 'password' : 'text'"
            ></v-text-field>
          </div>
        </div>
        <div class="col-sm-6 col-12 text-center">
          <div class="mt-5 "> موبایل</div>
          <div>
            <v-text-field
                v-model="PhoneNumber"
                class="mt-2"
                solo
                dense
                readonly
                :rules="phoneNumberRules"
            ></v-text-field>
          </div>
        </div>
        <div class="col-sm-6 col-12 text-center">
          <div class="mt-5 "> کد ملی</div>
          <div>
            <v-text-field
                v-model="NationalCode"
                class="mt-2"
                solo
                dense
                :rules="nationalCodeRules"
            ></v-text-field>
          </div>
        </div>
        <div class="col-sm-6 col-12 text-center">
          <div>
            <div class="mt-5 "> ایمیل</div>
            <v-text-field
                v-model="Email"
                class="mt-2"
                solo
                dense
                :rules="emailRules"
            ></v-text-field>
          </div>
        </div>
        <div v-if="$getUserData().role !== 5" class="col-sm-6 col-12 text-center">
          <div class="mt-5">دسترسی به دسته بندی تیکت ها</div>
          <v-autocomplete
              chips
              small-chips
              class="mt-2"
              multiple
              deletable-chips
              v-model="typeTickets"
              :items="typeTicketsItems"
              item-text="Name"
              item-value="TicketCategoryId"
              hide-details
              readonly
              solo
              dense
          ></v-autocomplete>
        </div>
        <div class="col-sm-6 col-12 text-center">
          <!--          <div>
                      <div class="mt-5 white&#45;&#45;text"> نقش</div>
                      <v-text-field
                          v-model="typeRole"
                          class="mt-2"
                          solo
                          dense
                          readonly
                      ></v-text-field>
                    </div>-->
        </div>
      </div>
      <div class="m-3">
        <v-btn
            dark
            @click="setProfileData"
            block
            color="primary"
            elevation="0"
        >
          <span class="">ویرایش حساب کاربری</span>
        </v-btn>
      </div>
    </v-form>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NavBar from "@/Ticketing/components/navBar";

export default {
  name: "profileClient",
  components: {NavBar},
  metaInfo() {
    return {
      title: 'ادمین - پروفایل'
    }
  },
  data: () => ({
    value: String,
    value2: String,
    typeRole: null,
    typeTickets: null,
    typeTicketsItems: [],
    isLoaded: true,
    isFormValid: false,
    showLoaderDialog: false,
    showResultDialog: false,
    dialogResult: null,
    ID: null,
    UserName: null,
    Email: null,
    Password: '',
    ConfirmPassword: '',
    Name: null,
    Family: null,
    NationalCode: '',
    TypeRole: null,
    PhoneNumber: '',
    IsActive: false,
    TypeAdvertisements: [],
    VeriyMobileCode: null,
    VeriyEmailCode: null,
    SmsNotification: false,
    PushNotification: false,
    EmailNotification: false,
    PasswordRules: [v => !!v || "ورود رمز عبور الزامی است", v => (v && v.length >= 6) || "طول رمز عبور باید بیشتر از 6 رقم باشد"],
    repeatPasswordRules: [v => !!v || "ورود تکرار رمز عبور الزامی است"],
    nationalCodeRules: [
      v => (v.length == 10 || v.length == 0) || 'کد ملی 10 رقم است.',
    ],
    emailRules: [
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(v) || 'ایمیل نامعتبر'
      }
    ],
    phoneNumberRules: [
      // value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
    FileUrl: null,
    ImageFileUrl: null

  }),
  mounted() {
    this.getTicketsCategory()
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
          this.Password === this.ConfirmPassword || "تکرار رمز عبور با رمز عبور یکسان نیست";
    }
  },
  methods:{
    getTicketsCategory() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetActiveTicketCategories", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.typeTicketsItems = JSON.parse(result)
            console.log(JSON.parse(result))
            this.getData()
          })
          .catch(error => console.log('error', error));
    },
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/MyProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log(json)
            this.ID = json.ID
            this.Name = json.Name === "null" ? '' : json.Name
            this.Family = json.Family === "null" ? '' : json.Family
            this.NationalCode = json.NationalCode === null ? '' : json.NationalCode
            this.UserName = json.UserName
            this.Email = json.Email === "null" ? '' : json.Email
            this.Password = json.Password
            this.ConfirmPassword = json.ConfirmPassword
            this.TypeRole = json.TypeRole
            this.PhoneNumber = json.PhoneNumber
            this.IsActive = json.IsActive
            this.VeriyMobileCode = json.VeriyMobileCode
            this.VeriyEmailCode = json.VeriyEmailCode
            this.SmsNotification = json.SmsNotification
            this.PushNotification = json.PushNotification
            this.EmailNotification = json.EmailNotification
            this.typeTickets = json.TicketCategoryIds
            this.isLoaded = true
          })
          .catch(error => console.log('error', error));
    },
    //TODO setProfileData
    setProfileData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("ID", this.ID);
      formdata.append("UserName", this.UserName);
      formdata.append("email", this.Email);
      formdata.append("Password", this.Password);
      formdata.append("ConfirmPassword", this.ConfirmPassword);
      formdata.append("Name", this.Name);
      formdata.append("Family", this.Family);
      formdata.append("NationalCode", this.NationalCode);
      formdata.append("TypeRole", this.TypeRole);
      formdata.append("PhoneNumber", this.PhoneNumber);
      formdata.append("IsActive", this.IsActive);
      formdata.append("VeriyMobileCode", this.VeriyMobileCode);
      formdata.append("VeriyEmailCode", this.VeriyEmailCode);
      formdata.append("SmsNotification", this.SmsNotification);
      formdata.append("PushNotification", this.PushNotification);
      formdata.append("EmailNotification", this.EmailNotification);
      if (this.typeTickets !== null) {
        for (var i = 0; i < this.typeTickets.length; i++) {
          formdata.append("TicketCategoryIds[" + i + "]", this.typeTickets[i]);
        }
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/MyProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.dialogResult = result
            this.showResultDialog = true
            this.getData()
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>